<script lang="ts">
	// Genuine shadcn-svelte Select scroll-down button (bits-ui), RESTYLED to our
	// tokens; lucide-core icon via our Icon wrapper. NO arbitrary values.
	import { Select as SelectPrimitive } from "bits-ui";
	import { cn, type WithoutChildrenOrChild } from "../../../utils.js";
	import { ChevronDown } from "lucide";
	import Icon from "../../../icon.svelte";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: WithoutChildrenOrChild<SelectPrimitive.ScrollDownButtonProps> = $props();
</script>

<SelectPrimitive.ScrollDownButton
	bind:ref
	data-slot="select-scroll-down-button"
	class={cn(
		"flex w-full cursor-default items-center justify-center bg-surface py-1 text-muted",
		className
	)}
	{...restProps}
>
	<Icon icon={ChevronDown} size={16} />
</SelectPrimitive.ScrollDownButton>
